import { MergedProjectDto, ProjectDto, ProjectSettingsDto, ProjectVersionDto } from "app/ApiClient";
import { NormalizedOriginProject } from "slices/originProjects/originProjectState";
import { LoadingState, ProjectDataViewModes } from "types";

export interface NormalizedProjectSettings extends ProjectSettingsDto {
  normalizedCheckedBatteries: string[];
  normalizedExcludedVariables: string[];
}

export interface ProjectState {
  currentProject: ProjectDto | null;
  projectSettings: NormalizedProjectSettings | null;
  updateProjectSettingsState: LoadingState;
  status: string | null | undefined;
  createdProject?: MergedProjectDto;

  selectedOriginProject: NormalizedOriginProject | null;

  projectSettingsLoadingState: LoadingState;
  createProjectLoadingState: LoadingState;
  getProjectLoadingState: LoadingState;
  updateProjectLatestEncodingVersionLoadingState: LoadingState;
  deleteProjectLoadingState: LoadingState;
  updateProjectLoadingState: LoadingState;

  createProjectError?: string;
  getProjectError?: string;
  updateProjectLatestEncodingVersionError?: string;
  deleteProjectError?: string;
  updateProjectError?: string;
  isAddProjectDialogOpened?: boolean;
  isAddCompositeProjectDialogOpened?: boolean;
  isOpenCreateCompositeProject: boolean;
  isOpenCreateCustomDataProject: boolean;
  isOpenCreateWalrDataProject: boolean;
  existingProject?: MergedProjectDto;
  projectVersions: ProjectVersionDto[];
  viewMode: ProjectDataViewModes;
  isDvFilterSelected:boolean;
  isRespondablesFilterSelected: boolean;
  isStacked: boolean;
}

export const initialProjectState: ProjectState = {
  currentProject: null,
  updateProjectSettingsState: LoadingState.idle,
  status : null, 
  projectSettings: null,
  selectedOriginProject: null,
  projectSettingsLoadingState: LoadingState.idle,
  createProjectLoadingState: LoadingState.idle,
  updateProjectLatestEncodingVersionLoadingState: LoadingState.idle,
  getProjectLoadingState: LoadingState.idle,
  deleteProjectLoadingState: LoadingState.idle,
  updateProjectLoadingState: LoadingState.idle,
  isAddProjectDialogOpened: false,
  isAddCompositeProjectDialogOpened: false,
  isOpenCreateCompositeProject: false,
  isOpenCreateCustomDataProject: false,
  isOpenCreateWalrDataProject: false,
  projectVersions: [],
  viewMode: ProjectDataViewModes.encodedData,
  isDvFilterSelected:false,
  isRespondablesFilterSelected: false,
  isStacked: false,
};
